import * as Yup from 'yup'
import { getDateByUserFormat, getMinDate, today } from '../../../../helpers/timeHelper'

export const initialValues = {
  number: '',
  date_of_issue: null,
  date_of_expire: null,
  type: { name: '', id: null },
  country: { name: '', id: null },
  city: { name: '', id: null },
  endorsement: {
    date_of_issue: null,
    date_of_expire: null,
    country: { name: '', id: null },
    city: { name: '', id: null },
    number: '',
  },
}

export const getValidationSchema = (dateFormat, isEndorsementRequired) => {
  const isEndorsementSectionRequired = (endorsement = {}) => {
    if (isEndorsementRequired) return true

    return Boolean(
      endorsement?.number ||
        endorsement?.country?.id ||
        endorsement?.country?.name ||
        endorsement?.date_of_issue ||
        endorsement?.date_of_expire ||
        endorsement?.city?.id ||
        endorsement?.city?.name
    )
  }

  return Yup.object().shape({
    type: Yup.object().shape({
      id: Yup.number().required('Field is required').nullable(),
    }),
    number: Yup.string().trim().required('Field is required'),
    country: Yup.object().shape({
      id: Yup.number().required('Field is required').nullable(),
    }),
    city: Yup.object().shape({
      id: Yup.mixed().test('Check city', 'Select city from list', function (value) {
        const { name } = this.parent

        return name ? Boolean(value) : true
      }),
    }),
    date_of_issue: Yup.date()
      .min(getMinDate, `Min date is ${getDateByUserFormat(getMinDate)}`)
      .max(today, `Max date is ${getDateByUserFormat(today)}`)
      .typeError(`Invalid date format, valid - ${dateFormat}`)
      .required('Field is required')
      .nullable(),
    date_of_expire: Yup.date()
      .min(Yup.ref('date_of_issue'), 'Date of expire must be later than date of issue')
      .typeError(`Invalid date format, valid - ${dateFormat}`)
      .nullable(),
    endorsement: Yup.object().shape({
      number: Yup.string()
        .trim()
        .nullable()
        .test('endorsement-number-required', 'Field is required', function (value) {
          if (!isEndorsementRequired) return true
          return Boolean(value)
        }),
      country: Yup.object().shape({
        id: Yup.number()
          .nullable()
          .test('endorsement-country-required', 'Field is required', function (value) {
            if (!isEndorsementSectionRequired(this.parent)) return true
            return Boolean(value)
          }),
      }),
      date_of_issue: Yup.date()
        .min(getMinDate, `Min date is ${getDateByUserFormat(getMinDate)}`)
        .max(today, `Max date is ${getDateByUserFormat(today)}`)
        .typeError(`Invalid date format, valid - ${dateFormat}`)
        .test('endorsement-date-of-issue-required', 'Field is required', function (value) {
          if (!isEndorsementSectionRequired(this.parent)) return true
          return Boolean(value)
        })
        .nullable(),
      date_of_expire: Yup.date()
        .min(Yup.ref('date_of_issue'), 'Date of expire must be later than date of issue')
        .typeError(`Invalid date format, valid - ${dateFormat}`)
        .test('endorsement-date-of-expire-required', 'Field is required', function (value) {
          if (!isEndorsementSectionRequired(this.parent)) return true
          return Boolean(value)
        })
        .nullable(),
      city: Yup.object().shape({
        id: Yup.mixed().test('Check city', 'Select city from list', function (value) {
          const { name } = this.parent

          return name ? Boolean(value) : true
        }),
      }),
    }),
  })
}
